import React from 'react'
import demoLogo from '../../assets/images/demo.png'

const DEMO_LOCATION_SHOW_ALL_TYPES_ID = '875'

const RentTypeHeader = ({locationInfo, locationId, minimumRentalTime}) => {
    const isDemoLocation = String(locationId || locationInfo?.id) === DEMO_LOCATION_SHOW_ALL_TYPES_ID

    const companyName = locationInfo?.company?.name || ''
    const city = locationInfo?.address?.city || ''
    const defaultLocationTitle = ['Voertuig huren bij', companyName, city].filter(Boolean).join(' ')
    const companyLogo = isDemoLocation ? demoLogo : locationInfo?.company?.logo
    const locationAddress = [
        locationInfo?.address?.street,
        locationInfo?.address?.houseNumber,
        locationInfo?.address?.zipCode
    ].filter(Boolean).join(' ')

    const minimumRentalUnit = String(minimumRentalTime?.unit || "").toLowerCase()
    const minimumRentalValue = Number(minimumRentalTime?.value)

    const rentalSubtitle =
        minimumRentalUnit === "day" && minimumRentalValue === 1
            ? "Van dagverhuur tot (longer) verhuur"
            : minimumRentalUnit === "day"
                ? "Van dagverhuur tot (longer) verhuur"
                : "Van een uur tot (short) lease"

    return (
        <div className="row">
            <div className="col-12 front-location-header">

                {
                    locationInfo.isFake ?
                        <div className="kav-bovag-header-wrapper">
                            <div className="kav-bovag-header">
                                <img src={require('../../assets/images/bovag.png')} alt=""/>
                            </div>
                        </div>

                        :
                        ''
                }

                <div>
                    <h1 className="location-title-1">
                        {
                            isDemoLocation ?
                                'Voertuig huren via het Mobility Platform'
                                :
                                defaultLocationTitle
                        }
                    </h1>
                    <h2 className="location-description">
                        {rentalSubtitle}
                    </h2>
                </div>
                {
                    companyLogo ?
                        <div>
                            <img className="location-company-logo" src={companyLogo} alt=""/>
                            {
                                locationInfo && !locationInfo.isFake && !isDemoLocation && locationAddress ?
                                    <h3 className="location-address mt-1">
                                        {locationAddress}
                                    </h3>
                                    :
                                    ''
                            }
                        </div>
                        :
                        ''
                }
            </div>
        </div>
    )
}

export default RentTypeHeader
